import clsx from 'clsx';
import { ReactNode, RefObject } from 'react';
import styles from './Button.module.css';

interface ButtonProps
  extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  appearance: 'primary' | 'secondary' | 'text';
  size: 's' | 'm' | 'l';
  children: ReactNode;
  disabled?: boolean;
  buttonRef?: RefObject<HTMLButtonElement | null>;
}

export const Button = ({ appearance, size, children, disabled, buttonRef, ...rest }: ButtonProps) => {
  return (
    <button
      ref={buttonRef}
      className={clsx(styles.button, styles[appearance], styles[size])}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
};
